"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_PATH = '/esp-sync/v1/settings';
var MAILCHIMP_PATH = 'mailchimp/v1/settings';

var EspSyncAPI =
/*#__PURE__*/
function () {
  function EspSyncAPI() {
    (0, _classCallCheck2.default)(this, EspSyncAPI);
  }

  (0, _createClass2.default)(EspSyncAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(BASE_PATH);
    }
  }, {
    key: "removeLastError",
    value: function removeLastError() {
      return _apiClient.default.delete(BASE_PATH + "/lasterror");
    }
  }, {
    key: "update",
    value: function update(patch) {
      return _apiClient.default.patch(BASE_PATH, {
        data: patch
      });
    }
  }, {
    key: "getMailchimpSyncStatus",
    value: function getMailchimpSyncStatus() {
      return _apiClient.default.get(MAILCHIMP_PATH);
    }
  }, {
    key: "setMailchimpSyncStatus",
    value: function setMailchimpSyncStatus(syncEnabled) {
      return _apiClient.default.put(MAILCHIMP_PATH, {
        data: {
          syncEnabled: syncEnabled
        }
      });
    }
  }]);
  return EspSyncAPI;
}();

exports.default = EspSyncAPI;
module.exports = exports.default;